module.exports = __webpack_public_path__ + "static/media/Group 1513.4afa3e51.svg";